/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path"
           unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff"
           active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>

    <el-menu-item v-for="menu in allmenu" :index="'/'+menu.url" :key="menu.menuid">
      <i class="iconfont" :class="menu.icon"></i>
      <span>{{ menu.menuname }}</span>
    </el-menu-item>


  </el-menu>
</template>
<script>

export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: 'icon-ziyuan',
          menuname: '账号信息',
          url: 'account'
        },
        {
          menuid: 33,
          icon: 'icon-yingyongguanli',
          menuname: '应用管理',
          hasThird: null,
          url: 'manage/app'
        },
        {
          menuid: 71,
          icon: 'icon-peie',
          menuname: '配额管理',
          hasThird: null,
          url: 'manage/quota'
        },
        {
          menuid: 72,
          icon: 'icon-liuliang',
          menuname: '流量分析',
          hasThird: null,
          url: 'manage/webTraffic'
        },
        {
          menuid: 128,
          icon: 'icon-dingdan2',
          menuname: '订单列表',
          hasThird: null,
          url: "pay/Order"
        },
        {
          menuid: 150,
          icon: 'icon-fapiao',
          menuname: '发票地址',
          hasThird: null,
          url: 'pay/Invoice'
        }
      ],
      msg: 'success'
    }
    this.allmenu = res.data


    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.el-menu-item span{
  margin-left: 0.5vw;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue